'use client';

import React from 'react';
import dynamic from 'next/dynamic';

// ReactPlayer is causing hydration errors, disabling SSR for it
// https://github.com/cookpete/react-player/issues/1428#issuecomment-1107908096
const ReactPlayer = dynamic(() => import('react-player/lazy'), { ssr: false });

export default function Video({ url }) {
	return (
		<div className="w-full h-auto">
			<ReactPlayer url={url} width="100%" controls />
		</div>
	);
}
